import { cn } from './ui-x';

export type TabItem = { id?: string | number; title: string };

type Props = {
  items: TabItem[];
  value?: string | null;
  onChange: (title: string) => void;
  className?: string;
};

/**
 * The reference's segmented control. Replaces the hand-rolled underline tabs
 * that were duplicated verbatim across MatchedJobsTable, ActiveProjects,
 * AllOffers and Invites — those used text-primary-6, which is undefined, so
 * the active tab had no colour change.
 */
const Tabs = ({ items, value, onChange, className }: Props) => (
  <div
    role='tablist'
    className={cn(
      'inline-flex max-w-full overflow-x-auto rounded-lg border bg-surface p-1 text-xs scrollbar-hide',
      className
    )}
  >
    {items.map((item) => {
      const active = value === item.title;
      return (
        <button
          key={item.id ?? item.title}
          type='button'
          role='tab'
          aria-selected={active}
          onClick={() => onChange(item.title)}
          className={cn(
            'whitespace-nowrap rounded-md px-3 py-1 font-semibold uppercase tracking-wide transition-colors',
            active
              ? 'bg-brand-navy text-white'
              : 'text-muted-foreground hover:text-brand-navy'
          )}
        >
          {item.title}
        </button>
      );
    })}
  </div>
);

export default Tabs;
